import React, { Component } from 'react';
import _isEmpty from 'lodash/isEmpty';
import Overlay from './Overlay';
import { generateEvent } from '../../../../utils/dataGrinch';
import MenuSublistFirst from './MenuSublistFirst';
import { makeValidUrl, getNavTag } from './utils';
import properties from '../../../../modules/ajio-util/properties';

class MenuList extends Component {
  constructor(props) {
    super(props);
    this.state = { isMouseInsideElement: false, isMouseInSideDiv: false,moreBtnActivated: false };
    this.liRef = React.createRef();
  }

  componentDidUpdate(prevProps,prevState) {
    if (this.props.isMouseInSideDiv === 'No' && prevProps.isMouseInSideDiv === 'Yes') {
      this.setState({ isMouseInSideDiv: false });
    }
 
    if (prevProps.activeDropdown !== this.props.activeDropdown) {
 
      if (this.props.menuIndex !== this.props.activeDropdown) {
        this.mouseExit()
 
      }
    }
  }
  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
    this.enableArrowNavigation();
  }

enableArrowNavigation = () => {
  const menuAnchors = document.querySelectorAll(`li#listItems-shopBy div[role="tab"]`);


  menuAnchors.forEach((anchor, index) => {

    anchor.addEventListener("keydown", (event) => {

      if (event.key === "ArrowRight") {
        event.preventDefault();
        const next = menuAnchors[index + 1];
        if (next) {
          next.focus();
        }
      }

      if (event.key === "ArrowLeft") {
        event.preventDefault();
        const prev = menuAnchors[index - 1];
        if (prev) {
          prev.focus();
        }
      }
    });
  });
};



  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = event => {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.setState({
        isMouseInsideElement: false,
        isMouseInSideDiv: false
      });
    }
  };

  mouseEnter = () => {
    this.setState({ isMouseInsideElement: true, isMouseInSideDiv: true });
  };

  mouseExit = () => {
    this.setState({ isMouseInsideElement: false });
  };

  linkClick(link, name) {
    generateEvent({
      Event: 'HeaderClick',
      value: {
        LinkName: name,
        LinkUrl: link,
        Screen: 'desktop'
      }
    });
  }
 
  expandClick = (e) => {
    try {
      e.preventDefault();
      e.stopPropagation();
      if (this.state.isMouseInsideElement) {
        this.mouseExit()
      } else {
        this.setActiveMenu()
        this.mouseEnter();
      }
    } catch (error) {
      console.log(error)
    }
  }
 
  makeAbFlagUrl = url => {
    let { ABFlagObj } = this.props;
    const searchAbFlagObj = JSON.stringify(ABFlagObj);

    if (url.includes('?')) {
      return `${url}${
        Object.keys(ABFlagObj)?.length > 0 ? `&searchAbFlagObj=${searchAbFlagObj}` : ''
      }`;
    } else {
      return `${url}${
        Object.keys(ABFlagObj)?.length > 0 ? `?searchAbFlagObj=${searchAbFlagObj}` : ''
      }`;
    }
  };

  handleFocusOut = (event) => {
    if (event.relatedTarget && this.liRef) {
      return;
    }
    this.mouseExit();
  }

  handleFocusIn = (event) => {
    this.setActiveMenu()
    this.mouseEnter();
  }

  setActiveMenu =() =>{
    this.props.setActiveDropdown(this.props.menuIndex)
  }

  render() {
    const {
      data = {},
      newDesignLuxe = false,
      isBrands = false,
      isNewBrandDirectoryDesktop,
      isStreet,
      ABFlagObj
    } = this.props;
    const { childDetails = [], url = '', name = '', newFlag = false, tag } = data;
    let {
      metaData: {
        sis = false,
        subHeaderHeight = 0,
        primaryHeaderHeight = 100,
        flyOutTopCoordinate = 87,
        current: { textColor = '#FFF' } = {}
      } = {}
    } = this.props;

    if (_isEmpty(childDetails) && _isEmpty(name)) {
      return null;
    }

    let anchorTagHeight = '40px';
    let fontSize = '16px';
    let liStyle = {
      height: anchorTagHeight
    };
    if (!sis || isStreet) {
      textColor = '#333';
      textColor = childDetails ? textColor : '#b19975';
      flyOutTopCoordinate = 87;
    } else {
      anchorTagHeight = '45px';
      // if(subHeaderHeight == 70) {
      //   anchorTagHeight = "35px";
      // }
      liStyle = {
        height: anchorTagHeight,
        lineHeight: '35px'
      };
    }

    if (newDesignLuxe) subHeaderHeight = 55;

    if (subHeaderHeight === 70 && !newDesignLuxe) {
      anchorTagHeight = '30px';
      fontSize = '14px';
    }

    const { location = {} } = window;
    const { pathname } = location;

    const anchorStyle = { color: textColor, height: anchorTagHeight, fontSize};

    const specialClass = pathname === url && pathname !== '#' ? 'selected-category-header' : '';
    const customClass = true;
    const anchorTag = (
      <div style={{position: 'relative',width: 'max-content'}}>
        {getNavTag({ tag, pathname, url,name,customClass })}
        <div id="menu-caret-link">
          <a
            href={makeValidUrl(url)}
            style={anchorStyle}
            title={name}
            onClick={() => this.linkClick(url, name)}
            className={`${specialClass} ${newDesignLuxe ? '' : 'alignTag'}`}
          >
            <span>{name}</span>
          </a>
          <button
            class='expand-nav-btn'
            onClick={childDetails.length ? this.expandClick : () => { }}
            aria-expanded={this.state.isMouseInsideElement}
            aria-controls={`ul-${name}`}
            aria-label={`${name} More`}
            disabled={!childDetails.length}
          ><img src={`${properties.getProperty('imageBaseUrl')}/static/img/filter-downarrow-icon.png`} alt='' /></button>
        </div>
      </div>
    );

    const listId = childDetails ? null : 'menu-highlight';
    const addBrandListClass = newDesignLuxe && isBrands ? 'brand-list-desktop-flyout' : '';
    const menuFlyoutClass =
      this.state.isMouseInSideDiv && this.state.isMouseInsideElement
        ? `menu-flyout  ${addBrandListClass}`
        : `menu-flyout close-seo-dropdown-menu  ${addBrandListClass}`;
    const dpOverlayClass = this.state.isMouseInSideDiv && this.state.isMouseInsideElement
      ? 'dp-overlay'
      : 'dp-overlay close-seo-dropdown-overlay';
    const flyOutStyle = { top: `${sis && !isStreet ? subHeaderHeight : flyOutTopCoordinate}px` };
    const overlayStyle = {
      top: `${sis && !isStreet ? primaryHeaderHeight + subHeaderHeight : primaryHeaderHeight}px`
    };
    const overlayStyleNewLuxe = { top: '165px' };
    return (
      <li
        id={listId}
        style={liStyle}
        data-test={`li-${name}`}
        onMouseEnter={childDetails.length ? this.handleFocusIn : this.setActiveMenu}
        onMouseLeave={childDetails.length ? this.handleFocusOut : null}
        onFocus={childDetails.length ? this.handleFocusIn : this.setActiveMenu}
        onBlur={childDetails.length ? this.handleFocusOut : null}
        ref={this.liRef}
      >
        <div id="menu-item-seperator" style={{ display: 'flex', alignItems: 'center' }} >
          {anchorTag}
        </div>
        {childDetails && (
          <div className={menuFlyoutClass} style={flyOutStyle} id={`ul-${name}`}>
            <ul className="menu-lfirst" role='tablist' aria-labelledby='shop-by'>
              {newDesignLuxe ? null : <span className="shopby-text" aria-label="Shop by:" aria-hidden={true} id="shop-by">Shop by: </span>}
              {childDetails.map((childData, j) => {
                return (
                  <MenuSublistFirst
                    key={j}
                    listItemNum={j}
                    data={childData}
                    linkClick={this.linkClick}
                    newDesignLuxe={newDesignLuxe}
                    isBrands={isBrands}
                    isNewBrandDirectoryDesktop={isNewBrandDirectoryDesktop}
                    ABFlagObj={ABFlagObj}
                    makeAbFlagUrl={this.makeAbFlagUrl}
                  />
                );
              })}
            </ul>
          </div>
        )}
        {childDetails && (
          <Overlay
            className={dpOverlayClass}
            onMouseEnter={this.mouseExit}
            style={newDesignLuxe ? overlayStyleNewLuxe : overlayStyle}
          />
        )}
      </li>
    );
  }
}

export default MenuList;
